import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRightIcon } from "@phosphor-icons/react";
import Link from "next/link";

export default function GetStarted({
  gettingStartedUrl,
}: {
  gettingStartedUrl: () => string;
}) {
  return (
    <Card className="bg-palette-mint-40030 border border-palette-mint-400">
      <CardContent className="p-spacing-7 gap-spacing-8 justify-between items-center sm:flex-col md:flex-row md:h-[120px]">
        <div className="flex flex-col gap-spacing-1 items-start">
          <h4 className="h4-Medium text-palette-text-primary">
            Get Started with Copilot Platform
          </h4>
          <p className="paragraphs-Large-Medium text-palette-text-secondary">
            Deploy your first AI-powered application with enterprise-grade
            security and scalability.
          </p>
        </div>
        <Link href={gettingStartedUrl()} target="_self">
          <Button
            type="button"
            className="h-11 w-[157px]! rounded-sm flex items-center gap-spacing-3 py-spacing-3 pr-spacing-3 pl-spacing-5 flex-none"
            iconRight={<ArrowRightIcon width={15} height={12.5} />}
            text="GET STARTED"
          ></Button>
        </Link>
      </CardContent>
    </Card>
  );
}
